export const CONGREGATIONS_GET = 'CONGREGATIONS_GET';
export const CONGREGATIONS_RECEIVE = 'CONGREGATIONS_RECEIVE';
export const CONGREGATION_SELECT = 'CONGREGATION_SELECT';
export const SET_CONGREGATION_ERRORS = 'SET_CONGREGATION_ERRORS';


// WEBPACK FOOTER //
// ./src/actionTypes/congregations.js